export default "__VITE_ASSET__BDaM_Ix9__"